module.exports = __webpack_public_path__ + "static/img/s5.aa802f2f.png";